import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AbastecimentoHorarioComponent } from './abastecimento-horario/abastecimento-horario.component';
import { CentralAjustePrecosModule } from './central-ajuste-precos/central-ajuste-precos.module';
import { CentralBloqueiosComponent } from './central-bloqueios/central-bloqueios.component';
import { ConfiguracaoNFeComponent } from './configuracao-nfe/configuracao-nfe.component';
import { PesquisaFrotaComponent } from './frota/pesquisa-frota/pesquisa-frota.component';
import { LoginComponent } from './login/login.component';
import { GerenciarMacroPostoComponent } from './macro-posto/gerenciar-macro-posto/gerenciar-macro-posto.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { PerfisModule } from './perfis/perfis.module';
import { CorpoComponent } from './precos-combustiveis/corpo/corpo.component';
import { RedeEspecialPostosComponent } from './rede-especial/rede-especial-postos/rede-especial-postos.component';
import { RegistroTransacoesComponent } from './registro-transacoes/registro-transacoes.component';
import { RelatoriosComponent } from './relatorios/relatorios.component';
import { SubFrotaSalvarAbastecimentoComponent } from './subFrota/sub-frota-salvar-abastecimento/sub-frota-salvar-abastecimento.component';
import { SubfrotaAprovacaoAbastecimentoEditadoComponent } from './subFrota/subfrota-aprovacao-abastecimento-editado/subfrota-aprovacao-abastecimento-editado.component';
import { SubfrotaEditAbastecimentosComponent } from './subFrota/subfrota-edit-abastecimentos/subfrota-edit-abastecimentos.component';
import { SubfrotaEditComponent } from './subFrota/subfrota-edit/subfrota-edit.component';
import { SubfrotaRelatorioAbastecimentosAlteradosComponent } from './subFrota/subfrota-relatorio-abastecimentos-alterados/subfrota-relatorio-abastecimentos-alterados.component';
import { SubfrotaShowComponent } from './subFrota/subfrota-show/subfrota-show.component';
import { SubfrotaComponent } from './subFrota/subfrota/subfrota.component';
import { UploadcsvModule } from './upload-csv-posto/uploadcsv.module';
import { VendaArlaModule } from './venda-arla/venda-arla.module';

import { GerenciarCotaComponent } from './gerenciar-cota/gerenciar-cota.component';
import { HabilitacaoSwapComponent } from './habilitacao-swap/habilitacao-swap.component';

const routes: Routes = [
  // { path: '', component: RedeEspecialPostosComponent },
  // { path: '', component: RedeEspecialPostosComponent },
  { path: 'central-bloqueios', component: CentralBloqueiosComponent },
  { path: 'login', component: LoginComponent },
  //{ path: 'preco-combustivel', component: CorpoComponent },
  { path: 'subfrota', component: SubfrotaComponent },
  { path: 'subfrota/incluir', component: SubfrotaEditComponent },
  { path: 'subfrota/alterar', component: SubfrotaEditComponent },
  { path: 'subfrota/consultar', component: SubfrotaShowComponent },
  { path: 'subfrota/excluir', component: SubfrotaShowComponent },
  { path: 'frota/pesquisa', component: PesquisaFrotaComponent },
  { path: 'subfrota', component: SubfrotaComponent },
  { path: 'subfrota/incluir', component: SubfrotaEditComponent },
  { path: 'subfrota/alterar', component: SubfrotaEditComponent },
  { path: 'subfrota/consultar', component: SubfrotaShowComponent },
  { path: 'subfrota/excluir', component: SubfrotaShowComponent },
  { path: 'frota/pesquisa', component: PesquisaFrotaComponent },
  // Abastecimentos tora
  {
    path: 'subfrota/relatorio-abastecimentos-editaveis',
    component: SubfrotaEditAbastecimentosComponent,
  },
  {
    path: 'subfrota/mostrar-abastecimento-editado',
    component: SubFrotaSalvarAbastecimentoComponent,
  },
  {
    path: 'subfrota/relatorio-abastecimentos-editados',
    component: SubfrotaRelatorioAbastecimentosAlteradosComponent,
  },
  {
    path: 'subfrota/mostrar-abastecimento-editado-salvar',
    component: SubfrotaAprovacaoAbastecimentoEditadoComponent,
  },
  { path: 'configuracao-nfe', component: ConfiguracaoNFeComponent },
  {
    path: 'subfrota/relatorio-abastecimentos-editaveis',
    component: SubfrotaEditAbastecimentosComponent,
  },
  {
    path: 'subfrota/mostrar-abastecimento-editado',
    component: SubFrotaSalvarAbastecimentoComponent,
  },
  {
    path: 'subfrota/relatorio-abastecimentos-editados',
    component: SubfrotaRelatorioAbastecimentosAlteradosComponent,
  },
  {
    path: 'subfrota/mostrar-abastecimento-editado-salvar',
    component: SubfrotaAprovacaoAbastecimentoEditadoComponent,
  },
  { path: 'configuracao-nfe', component: ConfiguracaoNFeComponent },
  { path: 'perfis', loadChildren: () => PerfisModule },
  { path: 'venda-arla', loadChildren: () => VendaArlaModule },
  { path: 'upload-csv', loadChildren: () => UploadcsvModule },

  { path: 'tela-preco-combustivel', component: CorpoComponent },
  { path: 'preco-combustivel', loadChildren: () => CentralAjustePrecosModule },
  { path: 'relatorios', component: RelatoriosComponent },
  { path: 'registro-transacoes', component: RegistroTransacoesComponent },
  { path: 'bloqueio-horario', component: AbastecimentoHorarioComponent },

  // passar um parametro para o componente RedeEspecialPostosComponent
  { path: 'central-de-acordos/:param', component: RedeEspecialPostosComponent },
  { path: 'gerenciar-cota', component: GerenciarCotaComponent },
  // passar um parametro para o componente RedeEspecialPostosComponent
  { path: 'central-de-acordos/:param', component: RedeEspecialPostosComponent },
  { path: 'aprovar-acordos', component: RedeEspecialPostosComponent },
  { path: 'central-de-acordos', component: RedeEspecialPostosComponent },
  { path: 'adm-rede', component: GerenciarMacroPostoComponent },
  { path: 'habilitacao-swap', component: HabilitacaoSwapComponent },
  { path: '**', component: PagenotfoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
